import SpecifierDescriptionMapper from './specifier-description-mapper';

const SpecifierDescriptionModel = {
    mapper: SpecifierDescriptionMapper,

    code: {
        type: String,
    },

    names: {
        type: Object,
    },
};

export default SpecifierDescriptionModel;
